import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import { theme } from '@upsolve/ui';

import ButtonRow from '../Layout/ButtonRow.div';
import { ButtonLink } from '../Inputs/Button.span';
import TwitterIcon from '../../../static/images/icon-twitter.svg';
import EmailIcon from '../../../static/images/icon-email.svg';
import ChatIcon from '../../../static/images/icon-chat.svg';
import RedditIcon from '../../../static/images/icon-reddit.svg';

const ShareRow = styled.div`
  margin-bottom: 0.5em;
  small {
    color: ${theme.colors.gray['900']};
    margin-right: 0.5em;
  }
  & > div {
    display: flex;
  }
  & > div > a {
    display: flex;
    height: 40px;
    width: 54px;
    padding: 0;
    font-size: 12px;
    ${(props) => {
      if (props.format === 'text') {
        return css`
          height: 40px;
          width: 50px;
        `;
      }
      return css`
        justify-content: center;
        align-items: center;
      `;
    }}
    & > * {
      margin-right: 0.25em;
    }
    &.show-sm {
      display: none;
      @media(max-width: 45em) {
        display: block;
      }
    }
    svg {
      height: 34px;
      width: 34px;
      &, path {
        fill: ${theme.colors.brand['500']};
      }
    }
    &.reddit > svg, &.reddit > svg > path {
      width: 22px;
      height: 22px;
    }
    &.email, &.sms {
      display: flex;
      text-align: center;
      & > svg {
        height: 20px;
        width: 20px;
      }
    }
    &.sms > svg {
      height: 36px;
      width: 36px;
    }
  }
`;

export default class ContentShareRow extends Component {
  render() {
    const { text, slug, format = 'icons' } = this.props;
    const url = 'https://'.concat(`upsolve.org/${slug}`.replace('//', '/'));
    // TODO: Facebook, Messenger
    return (
      <ShareRow format={format}>
        <small>Share this knowledge:</small>
        <div>
          <a aria-label="Twitter" size="xs" className="twitter" href={`https://twitter.com/intent/tweet?via=upsolvebk&text=${text}&url=${url}`} target="_blank" rel="noopener noreferrer">
            {format === 'text' ? 'Twitter' : <TwitterIcon />}
          </a>
          <a aria-label="Reddit" size="xs" className="reddit" href={`http://www.reddit.com/submit?url=${url}&title=${text}`}>
            {format === 'text' ? 'Reddit' : <RedditIcon />}
          </a>
          <a aria-label="Email" size="xs" className="show-sm email" href={`mailto:?subject=${text}&body="${text}" via Upsolve (${url})`}>
            {format === 'text' ? 'Email' : <EmailIcon />}
          </a>
          <a aria-label="SMS" size="xs" className="show-sm sms" href={`sms:?body=${text}&body="${text}" via Upsolve (${url})`} >
            {format === 'text' ? 'SMS' : <ChatIcon />}
          </a>
        </div>
      </ShareRow>
    );
  }
}
